import { render, staticRenderFns } from "./FlagInappropriateModal.vue?vue&type=template&id=eb0b264e&scoped=true"
import script from "./FlagInappropriateModal.vue?vue&type=script&lang=js"
export * from "./FlagInappropriateModal.vue?vue&type=script&lang=js"
import style0 from "./FlagInappropriateModal.vue?vue&type=style&index=0&id=eb0b264e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb0b264e",
  null
  
)

export default component.exports